import React, { useState } from 'react';
import { X, KeyRound } from 'lucide-react';
import api, { formatError } from '../lib/api';
import { toast } from 'sonner';

export default function ChangePasswordDialog({ open, onClose }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 4) return toast.error('New password too short');
    if (next !== confirm) return toast.error('Passwords do not match');
    setSaving(true);
    try {
      await api.post('/auth/change-password', { current_password: current, new_password: next });
      toast.success('Password updated');
      setCurrent(''); setNext(''); setConfirm('');
      onClose();
    } catch (err) { toast.error(formatError(err)); }
    finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div className="bg-white border border-zinc-900 shadow-brutal w-full max-w-md" onClick={(e) => e.stopPropagation()} data-testid="change-password-dialog">
        <div className="flex items-center justify-between border-b border-zinc-200 p-5">
          <div className="flex items-center gap-2">
            <KeyRound size={20} strokeWidth={2} />
            <div>
              <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500">ACCOUNT</div>
              <div className="font-display text-2xl font-black tracking-tighter">Change password</div>
            </div>
          </div>
          <button onClick={onClose} data-testid="close-change-pwd"><X size={20} /></button>
        </div>
        <form onSubmit={submit} className="p-5 space-y-4">
          <Field label="Current password" testid="cp-current" value={current} onChange={setCurrent} />
          <Field label="New password" testid="cp-new" value={next} onChange={setNext} />
          <Field label="Confirm new password" testid="cp-confirm" value={confirm} onChange={setConfirm} />
          <div className="flex items-center justify-end gap-2 pt-2 border-t border-zinc-200">
            <button type="button" onClick={onClose} className="border border-zinc-900 px-4 py-2 text-xs font-bold uppercase tracking-[0.15em] hover:bg-zinc-900 hover:text-white" data-testid="cancel-change-pwd">Cancel</button>
            <button type="submit" disabled={saving} className="bg-[#002FA7] text-white px-4 py-2 text-xs font-bold uppercase tracking-[0.15em] hover:bg-[#002088] disabled:opacity-60" data-testid="submit-change-pwd">
              {saving ? 'Updating...' : 'Update Password'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function Field({ label, testid, value, onChange }) {
  return (
    <div>
      <label className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500 block mb-2">{label}</label>
      <input data-testid={testid} type="password" required minLength={4} value={value} onChange={(e) => onChange(e.target.value)}
        className="w-full border border-zinc-300 focus:border-[#002FA7] outline-none px-3 py-2.5 bg-white" />
    </div>
  );
}
